/* eslint-disable no-unused-vars */
import _ from 'lodash';

import { assignedAndSyncedWorkOrderManipulationJson } from './json-manipulation/tasks';
import { assignedAndSyncedInspectionManipulationJson } from './json-manipulation/inspection';
import { assignedAndSyncedChecksManipulationJson } from './json-manipulation/checks';
import { decodeToken } from '@utilities/authentication';
import { PERMISSIONS } from 'permissions/constants';

const apisDataManipulationForStoringDataInIndexDB = async ({
  allApisResponse,
  initialLogin,
  isSettingUpdated,
  apisList,
  apisListMap
}) => {
  let manipulationJson = {};

  let workOrderCache = [],
    syncedWorkOrderCache = [],
    inspectionCache = [],
    syncedInspectionCache = [],
    assignedAssetCheckCache = [],
    syncedAssetCheckCache = [];

  const apiResponseKeys = Object.keys(allApisResponse);

  for (let indexString in apiResponseKeys) {
    const index = parseInt(indexString);
    const currentKey = apiResponseKeys[index];
    const currentAPIResponseData = allApisResponse[currentKey];

    const parserFunction = apisList[apisListMap[currentKey]]?.parser || null;
    if (parserFunction) {
      const res = await parserFunction({
        data: currentAPIResponseData,
        initialLogin,
        isSettingUpdated
      });

      manipulationJson = {
        ...manipulationJson,
        [currentKey]: res
      };
    } else if (currentKey === 'WorkOrderCache/MobileCache') workOrderCache = currentAPIResponseData;
    else if (currentKey === 'SyncedWorkOrderCache/MobileCache')
      syncedWorkOrderCache = currentAPIResponseData;
    else if (currentKey === 'InspectionCache/MobileCache') inspectionCache = currentAPIResponseData;
    else if (currentKey === 'SyncedInspectionCache/MobileCache')
      syncedInspectionCache = currentAPIResponseData;
    else if (currentKey === 'AssignedAssetCheckCache/MobileCache')
      assignedAssetCheckCache = currentAPIResponseData;
    else if (currentKey === 'SyncedAssetCheckCache/MobileCache')
      syncedAssetCheckCache = currentAPIResponseData;
  }

  const permissions = decodeToken()?.permissions || {};

  if (workOrderCache?.length > 0 || syncedWorkOrderCache?.length > 0) {
    const workorderRes = await assignedAndSyncedWorkOrderManipulationJson({
      workOrderCache:
        permissions[PERMISSIONS.MOBILE_ASSIGNED_WORKORDERS] && workOrderCache?.length > 0
          ? workOrderCache
          : [],
      syncWorkOrderCache: syncedWorkOrderCache,
      initialLogin
    });
    manipulationJson = {
      ...manipulationJson,
      'WorkOrderCache/SyncedWorkOrderCache': workorderRes
    };
  }

  if (inspectionCache?.length > 0 || syncedInspectionCache?.length > 0) {
    const newSyncedInspections = assignedAndSyncedInspectionManipulationJson({
      inspectionCache:
        permissions[PERMISSIONS.MOBILE_ASSIGNED_INSPECTIONS] && inspectionCache?.length > 0
          ? inspectionCache
          : [],
      syncedInspectionCache: syncedInspectionCache || [],
      initialLogin
    });

    manipulationJson = {
      ...manipulationJson,
      'InspectionCache/SyncedInspectionCache': newSyncedInspections
    };
  }

  if (assignedAssetCheckCache?.length > 0 || syncedAssetCheckCache?.length > 0) {
    const newChecksList = assignedAndSyncedChecksManipulationJson({
      checkCache:
        permissions[PERMISSIONS.MOBILE_ASSIGNED_CHECKS] && assignedAssetCheckCache?.length > 0
          ? assignedAssetCheckCache
          : [],
      syncCheckCache: syncedAssetCheckCache,
      initialLogin
    });
    manipulationJson = {
      ...manipulationJson,
      'AssignedAssetCheckCache/SyncedAssetCheckCache': newChecksList
    };
  }

  return manipulationJson;
};

export { apisDataManipulationForStoringDataInIndexDB };
